module.exports = __webpack_public_path__ + "img/A_hearts.9aa0ff0a.png";